import axios from 'axios';
import {api} from '../../constants/api';
import {errors as E} from 'common/constants/errors';

export const getFile = ({shumaId, fileID}) => dispatch => {
  const data = {
    shumaID: parseInt(shumaId, 10),
    fileID: parseInt(fileID, 10),
  };

  return axios.post(api.GET_FILE, data)
    .then(response => {
      const {body, errorCode} = response.data;
      if (errorCode < 0) throw new Error(E.SERVER_ERROR);

      return body.file;
    });
};

export const getFileFromOrder = ({orderID, fileID}) => dispatch => {
  const data = {
    orderID: parseInt(orderID, 10),
    fileID: parseInt(fileID, 10),
  };

  return axios.post(api.GET_ORDER_FILE, data)
    .then(response => {
      const {body, errorCode} = response.data;
      if (errorCode < 0) throw new Error(E.SERVER_ERROR);

      return body.file;
    });
};
